import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=bb42ba10&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb42ba10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb42ba10')) {
      api.createRecord('bb42ba10', component.options)
    } else {
      api.reload('bb42ba10', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=bb42ba10&scoped=true&", function () {
      api.rerender('bb42ba10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hSZt4Y2Pc75N/JS/comp/SearchFilterTokens.vue"
export default component.exports